import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
let spCol = "#fc4c4c";

export const LoadingStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: "absolute",
      zIndex: 1000,
      opacity: 1,
      background: theme.palette.primary.main,
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    spinner: {
      borderRadius: "50%",
      borderLeft: `0px ${spCol} solid`,
      borderRight: `0px ${spCol} solid`,
      animation: `$spinner 3s infinite linear`,
      width: "100px",
      height: "100px",
    },
    "@keyframes spinner": {
      from: {
        transform: "rotate(0deg)",
      },
      to: {
        transform: "rotate(360deg)",
      },
      // "0%": {
      //   borderLeft: `0px ${spCol} solid`,
      //   borderRight: `0px ${spCol} solid`,
      // },
      // "33%": {
      //   borderLeft: `100px ${spCol} solid`,
      //   borderRight: `0px ${spCol} solid`,
      // },
      // "66%": {
      //   borderLeft: `50px ${spCol} solid`,
      //   borderRight: `0px ${spCol} solid`,
      // },
      // "100%": {
      //   borderLeft: `0px ${spCol} solid`,
      //   borderRight: `0px ${spCol} solid`,
      // },
    },
  }),
);
